import { render, staticRenderFns } from "./a-textarea-minimal.vue?vue&type=template&id=4de0adb7&"
import script from "./a-textarea-minimal.vue?vue&type=script&lang=js&"
export * from "./a-textarea-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports